import styled from 'styled-components'

export const GridOfCheckbox = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 8px;
`
